import { render, staticRenderFns } from "./r-daily-quest-page.vue?vue&type=template&id=a5e134b6"
import script from "./r-daily-quest-page.vue?vue&type=script&lang=js"
export * from "./r-daily-quest-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5e134b6')) {
      api.createRecord('a5e134b6', component.options)
    } else {
      api.reload('a5e134b6', component.options)
    }
    module.hot.accept("./r-daily-quest-page.vue?vue&type=template&id=a5e134b6", function () {
      api.rerender('a5e134b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/daily-quest/r-daily-quest-page.vue"
export default component.exports